import { Helmet } from "react-helmet";

function Courses(props) {
  const isMobile = props.isMobile;

  const videoLinks = [
    { title: "Basics Tutorial", url: "https://drive.google.com/file/d/1Z215yUvc0jQR7XFKvl3JoiVolTzUlmO0/view?usp=sharing" },
    { title: "Advanced Tutorial", url: "https://drive.google.com/file/d/1fE3CHRWaExeaQmoFoKXyF8DMxcuzdpPx/view?usp=sharing" },
    { title: "More Webinar Recordings", url: "https://www.facebook.com/groups/1361718297857608/permalink/1430551784307592" },
  ];

  const youtubeVideos = [
    "K4IcZ6t3sy8",
    "Jg24bKV3iNU", "wXAQhM2wbTI", "0CEEQvjowYI",
    'EajkyBVCs0k', 'Yc7y5ARzaKo',
    "Wkom0eN-Ngg", "TvhZCU9yRZ8", "aZqpV0S5HXc",
    "2ShFzTIHSvw", "PNl2bvYX3AQ", "TLeSaFbVVjo",
    "UZg9n6gLB0o", "jmrsISf3zeo", 'cEcl0Hg1tok', "9lsHPkubqe8"
  ];

  return (
    <>
      <Helmet>
        <title>Nepeto - How to use Nepeto</title>
        <link rel="canonical" href="https://www.nepeto.com/tutorials" />
        <meta name="description" content="Free Nepeto video tutorials for Amazon sellers. Learn how to source products, use prep centers, and master Nepeto’s tools." />
        <meta name="keywords" content="amazon fba, product sourcing, nepeto tutorials, nepeto guide, fba help" />
      </Helmet>

      <section className="section">
        <div className="container">
          <h1
            style={{
              fontSize: props.isMobile ? "5vh" : "4vw",
              color: "#8c3e7c",
              textAlign: "center",
            }}
          >
            How to use Nepeto
          </h1>

          {/* --- Book a 1-on-1 Call --- */}
          <div
            className="box"
            style={{
              background: "linear-gradient(135deg, #8c3e7c, #5a2653)",
              color: "white",
              textAlign: "center",
            }}
          >
            <h2 className="subtitle has-text-weight-semibold" style={{ color: "white" }}>
              📅 Want a 1-on-1 Call With Us?
            </h2>
            <p
              style={{
                marginBottom: "1.25rem",
                fontSize: isMobile ? "1rem" : "1.15rem",
                lineHeight: 1.5,
              }}
            >
              Book a personal session to talk about maximizing your profits,
              getting the most out of Nepeto, selling on Amazon, and anything
              else on your mind.
            </p>
            <button
              className="button is-medium"
              style={{ background: "white", color: "#8c3e7c", fontWeight: "700" }}
              onClick={() =>
                window.open(
                  "https://calendly.com/igprojects/let-s-maximize-your-profits?back=1&month=2026-06"
                )
              }
            >
              Schedule My Call
            </button>
          </div>

          {/* --- Video Links --- */}
          <div className="box">
            <h2 className="subtitle has-text-weight-semibold">📺 Watch Webinar Recordings</h2>
            <button className="button is-success is-light is-fullwidth mb-2" style={{ fontWeight: "650" }} onClick={() => window.open("https://www.youtube.com/watch?v=G7UaEHmcLvI")}>
              → Our Latest Webinar!! ←
            </button>
            {videoLinks.map((video, i) => (
              <button key={i} className="button is-link is-light is-fullwidth mb-2" onClick={() => window.open(video.url)}>
                → {video.title} ←
              </button>
            ))}
          </div>

          {/* --- YouTube Grid --- */}
          <div className="box">
            <h2 className="subtitle has-text-weight-semibold">🎬 Video Tutorials</h2>
            <div className="columns is-multiline">
              <div className="column is-12-mobile is-4-tablet is-4-desktop">
                <img style={{ cursor: "pointer" }} onClick={() => window.open("https://www.facebook.com/groups/mysilentteam/permalink/8521816804601021/")} src="f1jim.png" />
              </div>
              <div className="column is-12-mobile is-4-tablet is-4-desktop">
                <img style={{ cursor: "pointer" }} onClick={() => window.open("https://www.facebook.com/groups/mysilentteam/permalink/8138398202942885/")} src="f2jim.png" />
              </div>
              {youtubeVideos.map((id, index) => (
                <div key={index} className="column is-12-mobile is-4-tablet is-4-desktop">
                  <iframe
                    width="100%"
                    height="100%"
                    src={`https://www.youtube.com/embed/${id}`}
                    title={`Nepeto Tutorial ${index + 1}`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Courses;
